export async function fetchWithRetry<T>(
  fn: () => Promise<T>,
  retries = 3,
  delayMs = 500
): Promise<T> {
  let lastError: unknown;

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      console.warn(`Попытка ${attempt}/${retries} не удалась:`, error);

      if (attempt < retries) {
        // Экспоненциальная задержка: 500ms, 1000ms, 2000ms...
        // Чтобы не долбить сервер сразу после ошибки
        const backoff = delayMs * Math.pow(2, attempt - 1);
        await new Promise((resolve) => setTimeout(resolve, backoff));
      }
    }
  }

  // Все попытки провалились — пробрасываем ошибку дальше
  throw lastError;
}